<template>
    <form @submit.prevent="handleSubmit">
        <fg-input v-model="form.id" v-validate="modelValidations.id" :error="getError('id')" name="id" autoComplete="off" type="id"></fg-input>
        <p-button slot="footer" :disabled="loading" nativeType="submit" type="primary" block class="mb-3">
            <i v-if="loading" class="fa fa-spinner fa-spin"></i>
            {{ loading ? null : 'Search' }}
        </p-button>
    </form>
</template>
<script>
import { Validator } from 'vee-validate'
import { clearFields } from '@/utils'
import { getError } from '@/utils/validateErrors'
import { Button } from '@/components/UIComponents'
export default {
    components: {
        [Button.name]: Button
    },
    props: {
        loading: Boolean,
        shouldClear: Boolean
    },
    data() {
        return {
            form: {
                id: ''
            },
            modelValidations: {
                id: {
                    required: true
                }
            }
        }
    },
    created() {
        const dictionary = {
            en: {
                attributes: {
                    id: 'user id'
                }
            }
        }
        Validator.localize(dictionary)
    },
    methods: {
        getError,
        async handleSubmit() {
            const isValid = await this.$validator.validateAll()
            if (isValid) {
                const values = {
                    id: this.form.id
                }
                this.$emit('submit', values)
                if (this.shouldClear) {
                    this.form = clearFields(this.form)
                    this.$validator.reset()
                }
            }
        }
    }
}
</script>
